import { inject, Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';

export class tokenModel{
  public name: string = "";
  public last_name: string = "";
  public company_country: string = "";
  public company_name: string = "";
  public company_id: string = "";
  public company_alias: string = "";
  public role: string = "";
  public email: string = "";
  public exp: number = 0;
  public iat: number= 0;
  public id: string = "";
  public modules: string[] = [];
  
}

@Injectable({
  providedIn: 'root'
})
export class DataService {
  public tiempo = 1500;

  public filtradoIndicadores = false;
  closeMessage = '<br/><br/><div> <span style="text-aling: center;font-size: 10pt;font-weight: 200;">Precione</span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 600;"> esc </span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 200;">para cerrar</span></div>';
  #token = localStorage.getItem('token');
  id = "";
  modules = [];
  user = "";
  moduleSelect = "";
  subModuleSelect = "";
  role = "";
  name = "";
  lastName = "";
  time = 1500;
  veActas = false;
  idInstitution = "";
  company_name = "";

  submodules = [
    {
      identifier: '',
      name: '',
      route: '',
      module: '',
    }
  ]

  modulesUser = [
    {
      identifier: '',
      name: '',
      route: '',
      module: '',
      platform: '',
      submodules: this.submodules,
    } 
  ]

  constructor(private cookies: CookieService){}

  initializationMenu(){
    this.modulesUser = [];
    this.submodules = [];
    if(this.#token){
      const decode = jwtDecode<tokenModel>(this.#token);
      this.user = decode.email;
      this.role = decode.role;
      this.id = decode.id;
      this.idInstitution = decode.company_id;
      this.name = decode.name;
      this.lastName = decode.last_name;
      this.company_name = decode.company_name;
      

      //obtencion de modulos
      this.modules = decode.modules.filter( (value, index, self) =>{
        return self.indexOf(value) === index;
      } );
      // console.log("🚀 ~ DataService ~ this.modules=decode.modules.filter ~ this.modules:", this.modules)

      const existeTab = decode.modules.filter(mod => mod === 'ale-altaactas' || mod === 'ale-actas_s');
      if(existeTab.length !== 0){
        this.veActas = true;
      }
      
      this.modulesUser.push({identifier: 'Inicio', name: 'Inicio', route: 'app', submodules: [], module: '', platform: ''});
      this.modulesUser.push({identifier: 'Inicio', name: 'Inicio', route: 'inicio', submodules: [], module: '', platform: ''});

      environment.modules.forEach( module =>{
        const findModule = this.modules.find(mod => mod === module.identifier);
        if(findModule && this.modulesUser.filter(mod => mod.identifier === findModule).length === 0){
          this.modulesUser.push(module)
        }
      });

      environment.submodules.forEach(submodule =>{
        const findSubModule = this.modules.find(sub => sub === submodule.identifier);
        if(findSubModule){
          this.submodules = this.submodules.concat(submodule);
        }
      });
      
      this.modulesUser.forEach(module =>{
        const findSubmodules = this.submodules.filter(sub => sub.module === module.module); 
        module.submodules = findSubmodules;
      });
    }

  }
  private vistaIndicadores(role: string){
    const sep = role.split('_');
    if(sep.includes('Responsables') && sep.includes('Seguimiento')){
      this.filtradoIndicadores = true;
    }else{
      this.filtradoIndicadores = false;
    }
  }
}
